import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import { Add } from '@material-ui/icons'

const styles = theme => ({
  flex: {
    flex: 1
  },
  colorPrimary: {
    backgroundColor: theme.palette.primary.light
  }
})
export default withStyles(styles)(
  class AdminToolbarComponent extends Component {
    static propTypes = {
      classes: PropTypes.object.isRequired,
      createAction: PropTypes.func,
      children: PropTypes.node,
      title: PropTypes.string
    }
    render() {
      const { classes, children, title, createAction } = this.props
      return (
        <AppBar
          elevation={1}
          classes={{ colorPrimary: classes.colorPrimary }}
          position="static">
          <Toolbar>
            <Typography
              variant="title"
              color="inherit"
              noWrap
              className={classes.flex}>
              {title || 'Title'}
            </Typography>
            <div style={{ marginRight: '60px' }}>{children}</div>
            {createAction && (
              <Button
                onClick={createAction}
                variant="fab"
                color="secondary"
                aria-label="add">
                <Add color="inherit" />
              </Button>
            )}
          </Toolbar>
        </AppBar>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/routes/Admin/components/CommonComponents/AdminToolbarComponent.js